import { z } from 'zod'

const recurringBaseSchema = z.object({
  name: z.string().trim().min(1, { message: '名前を入力してください' }),
  amount: z.number().positive({ message: '金額を入力してください' }),
  currency: z.enum(['JPY', 'USD']),
  category_id: z.string().nullable().optional(),
  day_of_month: z.number().int().min(1).max(31),
  paid_by: z.string().min(1, { message: '支払者を選択してください' }),
  scope: z.enum(['household', 'personal']),
  frequency: z.enum(['monthly', 'yearly']),
  frequency_months: z.array(z.number().int().min(1).max(12)).nullable().optional(),
  payment_method_id: z.string().nullable().optional(),
})

export const createRecurringSchema = recurringBaseSchema.refine(
  (data) => {
    if (data.frequency === 'yearly') {
      return data.frequency_months != null && data.frequency_months.length > 0
    }
    return true
  },
  { message: '年間頻度の場合は月を1つ以上選択してください', path: ['frequency_months'] },
)

export type CreateRecurringInput = z.infer<typeof createRecurringSchema>
